import styled from 'styled-components';

const Raw = styled.span`
  white-space: pre-line;
`;

export default Raw;
